module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "l-container"
  }, [_c('router-view', {
    attrs: {
      "contract": _vm.contract
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d57f9c4a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/Contract/Contract.vue
// module id = 1467
// module chunks = 0